"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgThumbsDown(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M7.488 0c.452 0 .82.375.82.833v.314h.093v.002l.098-.084C9.405.32 10.552 0 11.714 0h7.526c1.61 0 3.274.245 3.274 2.3 0 .292.01.586-.038.876l.29.2c.538.431.786 1.04.786 1.67v.49c0 .462-.049.894-.188 1.257.41.424.636.952.636 1.548v2.003c0 .608-.222 1.174-.617 1.625.12.302.173.653.173 1.047v.424c0 1.816-1.735 2.55-3.281 2.55h-4.076l.565 2.84c.101.517-.008 1.438-.23 2.26-.218.802-.564 1.578-.948 1.922l-.056.046c-.556.47-1.467.824-2.307.824-.59 0-1.144-.174-1.517-.606a1.279 1.279 0 01-.285-.592l-.614-3.116-3.71-4.702-4.553.027h-.032C.747 14.893 0 13.946 0 12.225V2.71C0 1.024.719 0 2.472 0h5.016zM19.24 1.53h-7.526c-.681 0-1.649.144-2.392.831l-.921.853v10.86l3.58 4.538.23.29.072.367.596 3.027c.06.028.174.057.344.057.511 0 1.074-.242 1.343-.47l.012-.01.011-.009c.092-.113.314-.518.494-1.18.206-.762.235-1.389.205-1.55l-.564-2.841-.364-1.832h5.915c.072 0 1.776-.011 1.776-1.02v-.425c0-.274-.04-.414-.063-.473l-.351-.88.622-.71a.902.902 0 00.236-.609V8.341a.64.64 0 00-.205-.477l-.682-.705.354-.921c.032-.083.085-.285.085-.703v-.49a.557.557 0 00-.182-.443l-.231-.158-.805-.553.163-.972c.02-.112.018-.286.017-.47V2.3c0-.465 0-.772-1.77-.772zM6.733 1.528h-4.26c-.22 0-.612.025-.758.197-.131.153-.21.521-.21.984v9.515c0 .86.078 1.139 1.007 1.139h.023l4.198-.025V1.529z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgThumbsDown;
exports.default = _default;